import { WALLET_SETTINGS_SERV_FAIL } from '../shared_consts'

export function getInitials(fullName) {
  // TODO: l10n?
  if (fullName == null || fullName.length < 1) {
    return ''
  }

  const splitName = fullName.split(/ +/g).filter(e => e)
  const firstName = splitName.length > 0 ? splitName[0] : null
  const lastName = splitName.length > 1 ? splitName[splitName.length - 1] : null
  return (
    (firstName ? firstName[0].toUpperCase() : '') +
    (lastName ? lastName[0].toUpperCase() : '')
  )
}

export function getDisplayName(
  full_name = '',
  businessNamesMappedToIds = {},
  id = ''
) {
  if (businessNamesMappedToIds[id]) {
    return businessNamesMappedToIds[id] === WALLET_SETTINGS_SERV_FAIL
      ? ' '
      : businessNamesMappedToIds[id]
  }
  return full_name
}
